import AddResourse from "../Pages/Resource Management/AddResourse";

export const endpoint = {
    getLogin: "admin/adminLogin",
    changePassword: "admin/changePassword",
    resetPassword: 'admin/resetPassword',
    blockWiseSchoolList: 'admin/blockWiseSchoolList',
    verifyOtp: 'admin/verifyOtp',
    regionList: 'admin/regionList',
    countryList: 'admin/countryList',
    schoolList: 'admin/schoolList',
    stateList: 'admin/stateList',
    district: 'admin/districtList',
    editSchool: 'admin/editSchool',
    blocklist: 'admin/blockList',
    addSchool: 'admin/addSchool',
    addSchoolCSV: 'admin/uploadCSVSchool',
    addTeacher: 'admin/addTeacher',
    adminForgotPassword: "admin/forgotPassword",
    getAdminProfile: "admin/getAdminProfile",
    getAllusers: 'admin/schoolList',
    getUserDetails: "admin/viewSchool",

    teacherList: 'admin/teacherList',
    teacherView: 'admin/viewTeacher',
    teracherObservatiion:'admin/getObservationDetail',
    updateTeacher: 'admin/editTeacher',
    teacherCSVFile: 'admin/uploadCSVTeacher',
    gradeList: 'admin/gradeList',
    updateStatus: 'admin/activeDeactivateSchool',
    activeDeactivateTeacher: 'admin/activeDeactivateTeacher',
    getallSchool: 'admin/allSchoolList',
    teacherArea:'admin/listOfTeacherBaseOnPriority',

    uploadTeacherlesson:"admin/uploadCSVCalendarLesson",
    getLessonTeacherList:"admin/getCalendarLessonList",


    getCms: "admin/getCMSDetail",
    updateCms: 'admin/updateCMS',
    getFAQList: 'admin/getFAQList',
    createFaq: 'admin/addFAQ',
    deleteFaq: 'admin/deleteFAQ',
    updateFaq: 'admin/updateFAQ',

    addcoach: 'admin/addCoach',
    CoachList: 'admin/coachList',
    updateCoach: 'admin/activeDeactivateCoach',
    uploadCSVCoach: 'admin/uploadCSVCoach',
    editCoach: 'admin/editCoach',
    viewCoach:'admin/viewCoach',
    coachCalender:'admin/calendarTeacherScheduleList',
    coacheTeacherListSeh:"admin/teacherScheduleSessionList",
    listObservation:'admin/listOfCoachObservation',
    getObservation:'admin/getDetailCoachObservation',
    totalsessionList:'admin/listOfTotalSession',
    totalsessionProgress:'admin/listOfTeacherProgress',
    totalVisited:'admin/listOfSchoolVisitProgress',
    assignedTeacherList:'admin/listOfAssignSchoolTeacher',

    programList: 'admin/programList',
    programStatus: 'admin/activeDeactivateEndProgram',
    schoolblockList: 'admin/blockWiseSchoolList',
    coachblockList: 'admin/blockWiseCoachList',
    addProgram: 'admin/addProgram',
    viewProgram: 'admin/viewProgram',
    viewProgramDetails: 'admin/viewProgramDetails',
    editProgram: 'admin/editProgram',
    uploadProgram:'admin/uploadCSVProgram',

    resourceList: 'admin/listOfResource',
    updateStatusResource: 'admin/activeDeactivateDeleteResource',
    AddResourse: 'admin/addResource',
    EditResourse: 'admin/editResource',



    logout: 'admin/logout',
    updateProfile:'admin/updateProfile',
    moduleList: 'admin/getModuleList',
    createRole: 'admin/createRole',
    getRoleList: 'admin/getRoleModuleWiseList',
    deleterole: 'admin/deleteRole',
    getRoleByid: 'admin/getRoleModuleById',
    editRole: 'admin/editRole',
    subAdminRole:'admin/getRoleList',
    getSubAdminList: 'admin/getSubAdminList',
    createSubAdmin: 'admin/createSubAdminRole',
    SubAdminView: 'admin/viewSubAdmin',
    updateSubAdmin: 'admin/updateSubAdmin',
    deleteSubAdmin: 'admin/deleteSubAdmin',
    blockSubAdmin: 'admin/blockUnblockSubAdmin',
    getDashboarddata: 'admin/dashboardData',
    uploadCsv:'admin/uploadCSVSubAdmin',


    getRegionlist: 'admin/getRegionList',
    getCountrylist: 'admin/getRegionList',
    getStatelist: 'admin/getRegionList',
    getDistictlist: 'admin/getRegionList',
    getBlocklist: 'admin/getRegionList',

    deleteRegion: 'admin/deleteRegion',
    deleteCountry: 'admin/deleteCountry',
    deleteState: 'admin/deleteState',
    deleteDistrict: 'admin/deleteDistrict',
    deleteBlock: 'admin/deleteBlock',

    AddRegion: 'admin/addRegion',
    AddCountry: 'admin/addCountry',
    AddState: 'admin/addState',
    AddDistrict: 'admin/addDistrict',
    AddBlock: 'admin/addBlock',

    UpdateRegion: 'admin/updateRegion',
    UpdateCountry: 'admin/updateCountry',
    UpdateState: 'admin/updateState',
    UpdateDistrict: 'admin/uploadCSVDistrict',
    UpdateBlock: 'admin/uploadCSVBlock',
    uploadRegion:'admin/uploadCSVRegion',
    uploadCountry:'admin/uploadCSVCountry',
    uploadState:'admin/uploadCSVState',
    uploadDistrict:'admin/uploadCSVDistict',
    uploadBlock:'admin/uploadCSVBlock',

    ViewDetailRegion: 'admin/getRegionDetail',
    ViewDetailCountry: 'admin/getCountryDetail',
    ViewDetailState: 'admin/getStateDetail',
    ViewDetailDistrict: 'admin/getDistrictDetail',
    ViewDetailBlock: 'admin/getBlockDetail',

    filterRegion:'admin/getRegionDropdown',
    filterCountry:'admin/getCountryDropdown',
    filterState:'admin/getStateDropdown',
    filterDistrict:'admin/getDistrictDropdown',
    filterBlock:'admin/getBlockDropdown',

    supportRequest:'admin/getRequestList',
    markasDone:'admin/updateRequestStatus',


    coachLogin: 'adminCoach/coachLogin',
    coachVerify:'adminCoach/coachVerifyOtp',
    coachResetOtp:'adminCoach/coachResendOtp',
    coachProfile:'adminCoach/coachProfile',
    assignedSchoolList:'adminCoach/assignedSchoolList',
    assignedSchoolTeacherList:'adminCoach/schoolAllTeacherList',
    assignedTeacherView:'adminCoach/viewTeacherDetail',
    assignedTeacherobservation:'adminCoach/getDetailCoachObservation',

    coachTargetList:'admin/listOfCoachTarget',
    blockwisecoachlist:'admin/blockWiseListOfCoach',
    coachwiseSchoolist:'admin/coachAssignedSchoolList',
    schoollistwiseteacher:'admin/schoolWiseTeacherList',
    coachWiselistOfCoachTarget:'admin/coachWiselistOfCoachTarget',
    AddTarget:'admin/addCoachTarget',
    ViewTarget:'admin/viewCoachTarget',
    updateTraget:'admin/editCoachTarget',
    uploadCoachTarget:'admin/uploadCSVCoachTarget',
    countapi:"admin/readSupportRequest",

    teacherUsageIndicator        :"admin/teacherUsageIndicator",
    coachUsageIndicator          :"admin/coachUsageIndicator",
    coachVisitTargetAchievement  :"admin/coachVisitTargetAchievement",
    teacherVisitTargetAchievement:"admin/teacherVisitTargetAchievement",
    reviewingCoachInteraction    :"admin/reviewingCoachInteraction",
    reviewingTeacherInteraction  :"admin/reviewingTeacherInteraction",
    teacherKeyInsight            :"admin/teacherKeyInsight",
    indicatorTracking            :"admin/indicatorTracking",



}